var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.18 44.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9ca5ad;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61,11.77A14.33,14.33,0,0,0,44.3.23C36.52,1.64,31.38,9.4,32,16.92,32.68,25.65,38.3,36.53,51.1,44a1.26,1.26,0,0,0,1.71-1.7A46.41,46.41,0,0,1,48.2,28.58,14.31,14.31,0,0,0,61,11.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29,11.77A14.33,14.33,0,0,0,12.36.23C4.58,1.64-.55,9.4.05,16.92.75,25.65,6.36,36.53,19.16,44a1.25,1.25,0,0,0,1.71-1.7,46.41,46.41,0,0,1-4.61-13.72A14.31,14.31,0,0,0,29,11.77Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComa);
export default __webpack_public_path__ + "static/media/coma.33782069260983952688793d067e3542.svg";
export { ForwardRef as ReactComponent };